export function Marquee({ items, light = false }) {
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y ${light ? "border-white/10 bg-navy" : "border-slate-200 bg-white"} py-5`} data-testid="marquee" aria-hidden="true">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((it, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-display text-lg font-medium tracking-tight sm:text-xl ${light ? "text-slate-300" : "text-slate-700"}`}>{it}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-teal-500" />
          </span>
        ))}
      </div>
    </div>
  );
}
